export default "__VITE_ASSET__ulZzm_$j__"